import React from 'react';

// AUDIT-BATCH-2 H2: the sidebar's inline SVG icons, moved out of components/Layout.jsx unchanged. Layout.jsx and config/navConfig.jsx import them.

/* ── Inline SVG icons ────────────────────────────────────────────────────── */

function DashIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <rect x="2" y="2" width="7" height="7" rx="1.5"/>
      <rect x="11" y="2" width="7" height="7" rx="1.5"/>
      <rect x="2" y="11" width="7" height="7" rx="1.5"/>
      <rect x="11" y="11" width="7" height="7" rx="1.5"/>
    </svg>
  );
}

function SetupIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <rect x="2" y="3"   width="16" height="3" rx="1" fillOpacity="0.4"/>
      <rect x="2" y="8.5" width="16" height="3" rx="1" fillOpacity="0.7"/>
      <rect x="2" y="14"  width="16" height="3" rx="1"/>
    </svg>
  );
}

function CommIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M3 5a2 2 0 012-2h10a2 2 0 012 2v2H3V5z"/>
      <path d="M3 9h14v8a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"/>
      <rect x="7" y="12" width="6" height="1.5" rx="0.75"/>
    </svg>
  );
}

function InvIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M10 2L3 6v8l7 4 7-4V6l-7-4z" fillOpacity="0.25"/>
      <path d="M10 2L3 6l7 4 7-4-7-4z"/>
      <path d="M3 6v8l7 4V10L3 6z" fillOpacity="0.7"/>
      <path d="M17 6v8l-7 4V10l7-4z" fillOpacity="0.5"/>
    </svg>
  );
}

function QualIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <rect x="5" y="2" width="10" height="16" rx="2" fillOpacity="0.2"/>
      <rect x="5" y="2" width="10" height="16" rx="2" fill="none" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M8 8l2 2 3-3" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="7" y="12.5" width="6" height="1.2" rx="0.6"/>
    </svg>
  );
}

function ShieldIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M10 2l7 3v5c0 4-3 7-7 8C7 17 4 14 4 10V5l6-3z" fillOpacity="0.25"/>
      <path d="M10 2l7 3v5c0 4-3 7-7 8C7 17 4 14 4 10V5l6-3z" fill="none" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M7.5 10l2 2 3-3" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function ReceivingIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M3 3h14v4H3z" fillOpacity="0.3"/>
      <path d="M3 3h14v4H3z" fill="none" stroke="currentColor" strokeWidth="1.25"/>
      <path d="M3 7h14l-1.5 10H4.5L3 7z" fillOpacity="0.15"/>
      <path d="M3 7h14l-1.5 10H4.5L3 7z" fill="none" stroke="currentColor" strokeWidth="1.25"/>
      <path d="M10 10v4m-2-2l2 2 2-2" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function DocsIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M5 2h7l4 4v12H4V2h1z" fillOpacity="0.15"/>
      <path d="M5 2h7l4 4v12H4V2z" fill="none" stroke="currentColor" strokeWidth="1.4"/>
      <path d="M12 2v4h4" fill="none" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M7 9h6M7 12h6M7 15h4" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
  );
}

function _InventoryIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <rect x="1" y="4"  width="18" height="2" rx="0.75"/>
      <rect x="1" y="9"  width="18" height="2" rx="0.75"/>
      <rect x="1" y="14" width="18" height="2" rx="0.75"/>
      <rect x="3" y="2"  width="1.5" height="16" rx="0.75" fillOpacity="0.5"/>
      <rect x="15.5" y="2" width="1.5" height="16" rx="0.75" fillOpacity="0.5"/>
    </svg>
  );
}

function FinanceIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <rect x="2"    y="12" width="3" height="6" rx="0.75" fillOpacity="0.5"/>
      <rect x="6.5"  y="8"  width="3" height="10" rx="0.75" fillOpacity="0.7"/>
      <rect x="11"   y="4"  width="3" height="14" rx="0.75"/>
      <rect x="15.5" y="6"  width="3" height="12" rx="0.75" fillOpacity="0.6"/>
      <path d="M2 11l5-4 4 2 4-5 3 1" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function ReportsIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <rect x="2"  y="10" width="3" height="8" rx="1"/>
      <rect x="7"  y="6"  width="3" height="12" rx="1"/>
      <rect x="12" y="2"  width="3" height="16" rx="1"/>
      <rect x="17" y="8"  width="3" height="10" rx="1" fillOpacity="0.5"/>
    </svg>
  );
}

function TrainingIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M10 2L1 7l9 5 9-5-9-5z"/>
      <path d="M5 9.5v4c0 1.5 2.5 3 5 3s5-1.5 5-3v-4" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M1 7v5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

function _HrIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <circle cx="7.5" cy="6" r="2.5"/>
      <path d="M2.5 16c0-2.8 2.2-5 5-5s5 2.2 5 5" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
      <circle cx="14.5" cy="7" r="2" fillOpacity="0.55"/>
      <path d="M12.5 16c0-2.1 0.9-3.8 2.3-4.6" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeOpacity="0.55"/>
    </svg>
  );
}

function _LegalIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M10 1.5L3 5v4.5C3 13.5 6 17 10 18.5 14 17 17 13.5 17 9.5V5L10 1.5z" fillOpacity="0.2"/>
      <path d="M10 1.5L3 5v4.5C3 13.5 6 17 10 18.5 14 17 17 13.5 17 9.5V5L10 1.5z" fill="none" stroke="currentColor" strokeWidth="1.4"/>
      <path d="M7 10l2 2 4-4" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function _IngIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M7 2h6v6l3 8H4l3-8V2z" fillOpacity="0.2"/>
      <path d="M7 2h6v6l3 8H4l3-8V2z" fill="none" stroke="currentColor" strokeWidth="1.4"/>
      <path d="M7 8h6" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
      <circle cx="8.5" cy="12.5" r="0.85" fillOpacity="0.7"/>
      <circle cx="11.5" cy="14" r="0.7" fillOpacity="0.5"/>
    </svg>
  );
}

function MoreDotsIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <circle cx="4"  cy="10" r="2"/>
      <circle cx="10" cy="10" r="2"/>
      <circle cx="16" cy="10" r="2"/>
    </svg>
  );
}

function HamburgerIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <rect x="2" y="4"  width="16" height="2" rx="1"/>
      <rect x="2" y="9"  width="16" height="2" rx="1"/>
      <rect x="2" y="14" width="16" height="2" rx="1"/>
    </svg>
  );
}

/* ── ImpersonationTimer ──────────────────────────────────────────────────── */

export { DashIcon, SetupIcon, CommIcon, InvIcon, QualIcon, ShieldIcon, ReceivingIcon, DocsIcon, _InventoryIcon, FinanceIcon, ReportsIcon, TrainingIcon, _HrIcon, _LegalIcon, _IngIcon, MoreDotsIcon, HamburgerIcon };
